<template>
<div>
    <div class="mb-0">

        <div class="landing-dark-bg pt-5 mt-20">
            <div class="container">
                <div class="row pb-10 pb-lg-20">
                    <div class="col-lg-12 pe-lg-16 mb-10 mb-lg-0">
                        <div class="rounded landing-dark-border p-9">
                            <h2 class="text-white">Contact Contabilitate</h2>

                            <span class="d-block fw-normal fs-4 text-gray-500">E-mail: <a href="mailto:decanat.mg@umft.ro" target="_blank">contabilitate@umft.ro</a><br/>
                                Tel: 0256 892 457</span>

                        </div>
                    </div>

                </div>
            </div>

            <div class="landing-dark-separator"></div>
            <div class="container">
                <div class="d-flex flex-column flex-md-row flex-stack ">
                    <div class="d-flex align-items-center order-2 order-md-1">
                        <router-link :to="{name:'home'}">
                            <img alt="Logo" v-bind:src="'/assets/media/logos/logoUMFT.png'" class="d-none theme-dark-show d-lg-inline h-65px">
                            <img alt="Logo" v-bind:src="'/assets/media/logos/logoUMFT.png'" class="d-lg-none theme-dark-show h-65px">

                            <img alt="Logo" v-bind:src="'/assets/media/logos/logoUMFTwhite.png'" class="d-none theme-light-show d-lg-inline h-65px">
                            <img alt="Logo" v-bind:src="'/assets/media/logos/logoUMFTwhite.png'" class="d-lg-none theme-light-show h-65px">
                        </router-link>
                        <span class="mx-5 fs-6 fw-semibold text-gray-600 py-7 py-lg-10" >UMF "Victor Babes" din Timișoara © {{ new Date().getFullYear() }}</span>
                    </div>
                    <div class="order-1 order-md-2">
                                <a class="" href="https://www.facebook.com/UMFVBT/" target="_blank" title="Facebook">
                                    <i class="fab fa-square-facebook fs-2x pe-3" style="color : #1877F2;"></i>
                                </a>
                                <a class="" href="https://www.instagram.com/umfvbt/" target="_blank" title="Instagram">
                                    <i class="fab fa-square-instagram fs-2x pe-3" style="color : #e4405f; "></i>
                                </a>
                                <a class="" href="https://www.linkedin.com/school/universitatea-de-medicină-și-farmacie-„victor-babeș”-din-timișoara/" target="_blank" title="Twitter">
                                    <i class="fab fa-linkedin fs-2x pe-3" style="color : #0077B5; "></i>
                                </a>
                                <a class="" href="https://www.youtube.com/channel/UCuuGv4PNyUse4kCWNDlVxBA" target="_blank" title="YouTube">
                                    <i class="fab fa-square-youtube fs-2x pe-3" style="color : #e02a20; "></i>
                                </a>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
export default {
    name: 'DFooter'
}
</script>
